import { getLiabilityPolicyStatusLabel, getPolicyLimtsText, getPolicyStatusNameFromId } from "../../../../../lib/labels";
import SimpleBoxDisplay from "../../../../common/SimpleBoxDisplay";
import CaseSummaryBox from "../CaseSummaryBox";

export default function LiabilitySummary({primaryLiability, classes}) {
    return <CaseSummaryBox title={'Liability Carrier'} tabNumber={1} type={'liabilities'}>
        {primaryLiability && <>
            <div className={classes.row}>
                <SimpleBoxDisplay label={'Name'} value={primaryLiability.insurance_carrier.name}/>
                <SimpleBoxDisplay label={'Liability Limit Patient'} value={getPolicyLimtsText(primaryLiability.policy_limit_patient)}/>
                <SimpleBoxDisplay label={'Liability Limit Accident'} value={getPolicyLimtsText(primaryLiability.policy_limit_accident)}/>
                <SimpleBoxDisplay label={'Claim Status'} value={getPolicyStatusNameFromId(primaryLiability.policy_status)}/>
            </div>
            <div className={classes.row}>
                <SimpleBoxDisplay label={'Liability'} value={getLiabilityPolicyStatusLabel(primaryLiability.liability_status)}/>
            </div>

            <div className={classes.row}>
                {primaryLiability.vehicle_make && <SimpleBoxDisplay label={'Vehicle Make'} value={primaryLiability.vehicle_make}/>}
                {primaryLiability.vehicle_model && <SimpleBoxDisplay label={'Vehicle Model'} value={primaryLiability.vehicle_model}/>}
                {primaryLiability.vehicle_year && <SimpleBoxDisplay label={'Vehicle Year'} value={primaryLiability.vehicle_year}/>}
            </div>
            {primaryLiability.vehicle_damage && <div className={classes.row}>
                <SimpleBoxDisplay label={'Vehicle Damage'} value={primaryLiability.vehicle_damage}/>
            </div>}
        </>}
        {!primaryLiability && <>No primary liability selected!</>}
    </CaseSummaryBox>
}